import type { IRequestCache } from '@/utils/apiStorage';
import { ISSUE_PR_API_PREFIX } from '@/constant/index';

const TIMEOUT = 5000;
const RETRY = 2;

export const storageApis: IRequestCache[] = [
  {
    url: `${ISSUE_PR_API_PREFIX}/api/v1/issues`,
    timeout: 5000,
    retry: RETRY,
    method: 'get',
    excludeStatusCode: [401, 403, 404]
  },
  {
    url: `${ISSUE_PR_API_PREFIX}/api/v1/merge_requests`,
    timeout: TIMEOUT,
    retry: RETRY,
    method: 'get',
    excludeStatusCode: [401, 403, 404]
  },
  {
    url: `${ISSUE_PR_API_PREFIX}/api/v1/projects/{projectId}/isource/merge_requests`,
    timeout: TIMEOUT,
    retry: RETRY,
    method: 'get',
    excludeStatusCode: [401, 403, 404]
  },
  {
    url: '${ISSUE_PR_API_PREFIX}/api/v1/issue/{projectId}/issues',
    timeout: TIMEOUT,
    retry: RETRY,
    method: 'get',
    excludeStatusCode: [401, 403, 404]
  }
];
